import { useEffect } from 'react';
import { useLastMessageForRoom } from '../hooks/useAdminRoomManager';
import { DateTime } from 'luxon';
import avatarImg from "../assets/avatar.jpg";
import { Avatar, Conversation } from '@chatscope/chat-ui-kit-react';
import { chatState, userStore } from '../zustand';


function ConversationSummary({ room, index, setActiveDm, ...props }) {
    const { data, error } = useLastMessageForRoom(room.id);
    const lastMessage = data?.messages?.[0];
    const user = userStore((state) => state.user);
    const roomId = chatState((state) => state.roomId);

    // Get summary (if text)
    let summary = '';
    if (lastMessage?.messageType === 'text') {
        summary = lastMessage.content.length > 50
            ? lastMessage.content.slice(0, 50) + '…'
            : lastMessage.content;
    } else if (lastMessage) {
        summary = `[${lastMessage.messageType}]`;
    }

    const time = (() => {
        if (!lastMessage?.createdAt) return '';
        const msgDate = DateTime.fromISO(JSON.parse(lastMessage.createdAt));
        const now = DateTime.local();
        if (msgDate.hasSame(now, 'day')) {
            return msgDate.toFormat('h:mm a');
        } else if (msgDate.plus({ days: 1 }).hasSame(now, 'day')) {
            return 'yesterday';
        } else {
            return msgDate.toRelative();
        }
    })();

    return (
        <Conversation
            key={index}
            info={summary}
            lastActivityTime={<>{time}</>}
            name={room.name || `Project ${index + 1}`}
            onClick={() => setActiveDm(room)}
            unreadCnt={!(room.type == 'user' && room.entityId == user.id) && room.msgs?.length > 0 ? +room.msgs.length : ''}
            {...props}
            active={roomId === room.id}
        >
            <Avatar
                name={room.title || `Project ${index + 1}`}
                src={room.type === 'user' ? avatarImg : avatarImg}
            />

        </Conversation>
    );
}

export default ConversationSummary;